const colsInjectionKey = Symbol("cols");
const isFirstColFixedInjectionKey = Symbol("isFirstColFixed");
const isLastColFixedInjectionKey = Symbol("isLastColFixed");
const isColsResizableInjectionKey = Symbol("isColsResizable");
const MIN_WIDTH_COL_RESIZE = 80;
export {
  MIN_WIDTH_COL_RESIZE,
  colsInjectionKey,
  isColsResizableInjectionKey,
  isFirstColFixedInjectionKey,
  isLastColFixedInjectionKey
};
